export const appVersion = '1.2.4-SNAPSHOT-06';

export const appBuildInfo = {
    version: '1.2.4-SNAPSHOT-06',
    timestamp: '20260928-23h49',
    gitHash: '54348c4',
    full: '1.2.4-SNAPSHOT-06 (Build 20260928-23h49 - 54348c4)'
};